import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { http, formatApiError } from "../../lib/api";
import { toast } from "../../lib/notify";
import { FIN_DOC_TYPES, FIN_PARSED_TYPES, BTN_DARK } from "./finConst";

const inp = "px-2.5 py-1.5 text-xs border border-slate-300 rounded-md bg-white outline-none focus:border-amber-500";

// Beyanname (PDF) / Mizan / Bağımsız Denetim Raporu / BDR Ek 4 yükleme; beyannamede firma-yıl-dönem PDF'ten okunur, diğerlerinde formdan alınır
export default function FinUploadForm({ companies, onDone }) {
  const [f, setF] = useState({ doc_type: "kurumlar", company: "", year: "", period: "" });
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);
  const parsed = FIN_PARSED_TYPES.includes(f.doc_type);
  const submit = async (e) => {
    e.preventDefault();
    const file = fileRef.current?.files?.[0];
    if (!file) { toast.error("Dosya seçin"); return; }
    const fd = new FormData();
    fd.append("file", file);
    fd.append("doc_type", f.doc_type);
    if (f.company) fd.append("company", f.company);
    if (f.year) fd.append("year", f.year);
    if (f.period) fd.append("period", f.period);
    setBusy(true);
    try {
      const { data } = await http.post("/fin/docs", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const n = data.parsed?.items?.length || 0;
      toast.success(`${data.company} · ${data.year} yüklendi${n ? ` — ${n} kalem okundu` : parsed ? " — kalemler okunamadı (dosya yine de saklandı)" : ""}${data.replaced ? " · önceki sürüm arşivlendi" : ""}`);
      fileRef.current.value = "";
      onDone?.(data);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="flex flex-wrap items-end gap-2 p-3 rounded-lg border border-dashed border-slate-300 bg-slate-50/60" data-testid="fin-upload-form">
      <label className="flex flex-col gap-1 text-[10px] font-semibold uppercase tracking-wider text-slate-500">Belge Türü
        <select value={f.doc_type} onChange={(e) => setF({ ...f, doc_type: e.target.value, period: "" })} className={inp} data-testid="fin-upload-type">
          {Object.entries(FIN_DOC_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </label>
      <label className="flex flex-col gap-1 text-[10px] font-semibold uppercase tracking-wider text-slate-500">Firma {parsed ? <span className="normal-case font-normal text-slate-400">(PDF'ten okunur; boş bırakılabilir)</span> : <span className="text-red-600">*</span>}
        <input list="fin-company-list" value={f.company} onChange={(e) => setF({ ...f, company: e.target.value })} placeholder="Unvan" className={`${inp} w-56`} data-testid="fin-upload-company" />
        <datalist id="fin-company-list">{companies.map((c) => <option key={c} value={c} />)}</datalist>
      </label>
      <label className="flex flex-col gap-1 text-[10px] font-semibold uppercase tracking-wider text-slate-500">Yıl {!parsed && <span className="text-red-600">*</span>}
        <input type="number" min="2000" max="2100" value={f.year} onChange={(e) => setF({ ...f, year: e.target.value })} placeholder="örn. 2025" className={`${inp} w-24`} data-testid="fin-upload-year" />
      </label>
      {f.doc_type !== "kurumlar" && (
        <label className="flex flex-col gap-1 text-[10px] font-semibold uppercase tracking-wider text-slate-500">Dönem
          <select value={f.period} onChange={(e) => setF({ ...f, period: e.target.value })} className={inp} data-testid="fin-upload-period">
            <option value="">{f.doc_type === "gecici" ? "PDF'ten oku" : "Yıllık"}</option>
            {[1, 2, 3, 4].map((p) => <option key={p} value={p}>{p}. Dönem</option>)}
          </select>
        </label>
      )}
      <label className="flex flex-col gap-1 text-[10px] font-semibold uppercase tracking-wider text-slate-500">Dosya
        <input ref={fileRef} type="file" accept={parsed ? ".pdf" : ".pdf,.xlsx,.xls"} className="text-xs" data-testid="fin-upload-file" />
      </label>
      <button type="submit" disabled={busy} className={BTN_DARK} data-testid="fin-upload-submit"><Upload className="w-3.5 h-3.5" /> {busy ? "Yükleniyor…" : "Yükle"}</button>
    </form>
  );
}
